var affiliateConfig = {
    default: {
        quotesOnly: false,
        topOfferBadge: true,
        helpPhoneNumber: "1-855-760-0686",
        hideIssuerLogos: false,
        privacyPolicyURL: "https://savvy.insure/privacy",
        trellisPrivacyPolicyURL: "https://trellisconnect.com/privacy-policy/",
        disabledIssuers: [],
        agentsAvailable: false,
        businessPartnersURL: "https://savvy.insure/business-partners",
        hidePhoneNumber: true,
    },
    amex: {
        quotesOnly: true,
        topOfferBadge: false,
        helpPhoneNumber: "1-844-628-2639",
        hideIssuerLogos: true,
        privacyPolicyURL: "https://savvy.insure/amex-privacy",
        trellisPrivacyPolicyURL: "https://trellisconnect.com/trellis-end-user-privacy-policy/",
        agentsAvailable: true,
        businessPartnersURL: undefined,
        hidePhoneNumber: false,
    },
    tricia: {
        quotesOnly: true,
    },
    sweaterventures: {
        quotesOnly: true,
    },
    demo: {
        quotesOnly: true,
    },
    abode: {
        quotesOnly: true,
    },
};
export default affiliateConfig;
